import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AppShell } from './components/AppShell';
import { JobFinanceProvider } from './lib/jobFinance';
import LoginPage from './pages/LoginPage';
import AcceptInvitationPage from './pages/AcceptInvitationPage';
import DashboardPage from './pages/DashboardPage';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import NewJobPage from './pages/NewJobPage';
import UsersPage from './pages/UsersPage';
import CompaniesPage from './pages/CompaniesPage';
import VehicleLookupPage from './pages/VehicleLookupPage';
import AccountsPage from './pages/AccountsPage';
import CustomersPage from './pages/CustomersPage';
import SubcontractorsPage from './pages/SubcontractorsPage';
import CompanySettingsPage from './pages/CompanySettingsPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <JobFinanceProvider>
              <AppShell />
            </JobFinanceProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="archive" element={<JobsPage initialTab="archived" />} />
        <Route path="jobs/new" element={<NewJobPage />} />
        <Route path="jobs/archived/:jobId" element={<JobDetailPage archived />} />
        <Route path="jobs/:jobId" element={<JobDetailPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route
          path="customers"
          element={
            // Not admin-only: dispatchers and managers keep customers too. The
            // page itself turns away any other role (canManageCustomers).
            <ProtectedRoute>
              <CustomersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="subcontractors"
          element={
            <ProtectedRoute requireAdmin>
              <SubcontractorsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute requireAdmin>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route path="companies" element={<CompaniesPage />} />
        <Route
          path="settings"
          element={
            <ProtectedRoute requireAdmin>
              <CompanySettingsPage />
            </ProtectedRoute>
          }
        />
        <Route path="change-password" element={<ChangePasswordPage />} />
        <Route path="lookup" element={<VehicleLookupPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
